import { BaseRepository } from '@/base/base-repository';
import { SuiClient } from '@mysten/sui/client';

class SuinsRepository extends BaseRepository {
	private addressesCache: Map<string, { name: string | false; timestamp: number }> = new Map();

	private namesCache: Map<string, { address: string | false; timestamp: number }> = new Map();

	private cacheDuration: number = 6 * 60 * 60 * 1000;

	async resolveName(client: SuiClient, address: string): Promise<string | false> {
		const currentTime = Date.now();

		const cachedResult = this.addressesCache.get(address);
		if (cachedResult && currentTime - cachedResult.timestamp < this.cacheDuration) {
			return cachedResult.name;
		}

		const res = await client.resolveNameServiceNames({
			address,
			limit: 1,
		});
		const name = res.data.at(0) || false;

		this.addressesCache.set(address, { name, timestamp: currentTime });

		return name;
	}

	async resolveAddress(client: SuiClient, name: string): Promise<string | false> {
		const currentTime = Date.now();
		const cachedResult = this.namesCache.get(name);
		if (cachedResult && currentTime - cachedResult.timestamp < this.cacheDuration) {
			return cachedResult.address;
		}

		try {
			const res = await client.resolveNameServiceAddress({
				name,
			});
			const address = res || false;

			this.namesCache.set(name, { address, timestamp: currentTime });

			return address;
		} catch {
			return false;
		}
	}
}

export const suinsRepository = new SuinsRepository();
